import { cgiCallWrapper } from './cgiCallWrapper'
import showAlert from './showAlert'

export const searchAMS = async params => {
    const serviceInfo = {
        serviceID: params.serviceProviderId,
        serviceName: '',
    }
    // 得到服务商信息
    const accountRes = await cgiCallWrapper(
        params.getAccountInfo,
        {
            account_id: params.serviceProviderId,
        },
        false
    )
    if (accountRes.code !== 0 && accountRes.code !== '0') {
        showAlert('error', '查不到该服务商的信息')
        return
    } else {
        if (accountRes.data.account_id && accountRes.data.account_id === Number(serviceInfo.serviceID)) {
            serviceInfo.serviceName = accountRes.data.nick_name
        } else {
            showAlert('error', '服务商id不存在')
            return
        }
    }

    return serviceInfo
}
